import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import {getFilterGroupValues} from "../../../misc/utils";

const FeatureInfoMaterial = (props) => {

  const {selectionFeatureInfo, filterGroups, feature} = props;

  const currentFeature = feature || selectionFeatureInfo;

  const materialFilterGroup = filterGroups.find(filterGroup => filterGroup.name.trim() === "Countertop Material");
  if (!materialFilterGroup) {
    return null
  }

  const featureMaterialValues = getFilterGroupValues(currentFeature, materialFilterGroup);
  if (!featureMaterialValues) {
    return null
  }

  const materialFilterValue = materialFilterGroup.values.find(val => val.id === featureMaterialValues[0]);
  // console.log("materialFilterValue", materialFilterValue);

  return (
    <div className="product-info__material">
      <FormattedMessage id="quotingTool.featureInfo.material"/>
      <span className="product-info__material-value bold"> {materialFilterValue.displayText}</span>
    </div>
  );
};

FeatureInfoMaterial.propTypes = {
  feature: PropTypes.object
}

const mapStateToProps = (store) => {
  return {
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    filterGroups: store.filterState.filterGroups,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(FeatureInfoMaterial);
